import './styles/global.scss';
import Page from '@components/page/page';
import machine from '@state-machine/machine';
import controller from './controller';
import Router from './router';
export default class App {
    router;
    page;
    constructor() {
        this.router = new Router(this.getRouteObjects());
        this.page = new Page(machine, this.router.handleLink);
    }
    init() {
        this.page.mount();
        this.router.initialLoad();
    }
    getRouteObjects() {
        return [
            {
                pathname: '/',
                callback: () => machine.makeTransition(machine.value, 'navigateOptionsList', { currentRoute: '/' }),
            },
            {
                pathname: '/picker',
                callback: () => {
                    const pickerList = controller.getPickerList();
                    if (pickerList) {
                        machine.makeTransition(machine.value, 'navigatePicker', {
                            pickerList,
                            currentRoute: '/picker',
                        });
                    }
                    else {
                        this.router.navigate('/');
                        this.page.showMessage('noValidOptions');
                    }
                },
            },
        ];
    }
}
